import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TypesenseService } from '../../services/typesense.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-new-mega-launch-campaign',
    templateUrl: './new-mega-launch-campaign.component.html',
    styleUrls: ['./new-mega-launch-campaign.component.scss'],
    standalone: false
})
export class NewMegaLaunchCampaignComponent implements OnInit, OnDestroy {
   @Input() prefetchedData: any | null = null;

   isAccepted: boolean = false;
   totalInvestorsTarget: number = 300;
   remainingInvestors: number = 300;
   progressPercent: number = 0;

   daysLeft: number = 0;
   hoursLeft: number = 0;
   minutesLeft: number = 0;
   secondsLeft: number = 0;

   private countdownInterval: any;
   countdownLoading: boolean = true;
   private isBrowser: boolean;
   displayInvestNowButton: boolean = true;

   constructor(
      public activeMegaCampaignModal: NgbActiveModal,
      private typesenseService: TypesenseService,
      @Inject(PLATFORM_ID) private platformId: Object
   ) {
      this.isBrowser = isPlatformBrowser(this.platformId);
   }

   ngOnInit(): void {
      if (this.prefetchedData) {
         this.consumeCrowdfundingProgress(this.prefetchedData);
      } else {
         this.typesenseService.fetchCrowdfundingProgressData3().subscribe({
            next: (res: any) => this.consumeCrowdfundingProgress(res),
            error: (err) =>
               console.error('CrowdfundingProgress v3 error:', err),
         });
      }
   }

   closeMegaLaunchCampaignModal() {
      if(this.isBrowser) {
         sessionStorage.setItem('megaLaunchCampaignPopup', 'true');
      }
      this.clearCountdown();
      this.activeMegaCampaignModal.close();
   }

   openInvestNowLink() {
      window.open('https://invest.musaffa.com/?utm_source=mainwebsite&utm_medium=clock&utm_campaign=cf-2025', '_blank');
      this.closeMegaLaunchCampaignModal()
   }

   ngOnDestroy(): void {
      this.clearCountdown();
   }

   private clearCountdown(): void {
      if (this.countdownInterval) {
         clearInterval(this.countdownInterval);
         this.countdownInterval = null;
      }
   }

   private setCountdownToZero(): void {
      this.daysLeft = 0;
      this.hoursLeft = 0;
      this.minutesLeft = 0;
      this.secondsLeft = 0;
      this.displayInvestNowButton = false;
      setTimeout(() => {
         this.displayInvestNowButton = true;
      }, 2000);
   }

   private updateCountdown(deadline: Date): void {
      const now = new Date().getTime();
      const distance = Math.max(0, deadline.getTime() - now);

      if (distance <= 0) {
         this.setCountdownToZero();
         this.clearCountdown();
         this.countdownLoading = false;
         return;
      }

      const dayMs = 1000 * 60 * 60 * 24;
      const hourMs = 1000 * 60 * 60;
      const minuteMs = 1000 * 60;

      this.daysLeft = Math.floor(distance / dayMs);
      this.hoursLeft = Math.floor((distance % dayMs) / hourMs);
      this.minutesLeft = Math.floor((distance % hourMs) / minuteMs);
      this.secondsLeft = Math.floor((distance % minuteMs) / 1000);
      this.countdownLoading = false;
   }

   pad2(value: number): string {
      return value < 10 ? `0${value}` : `${value}`;
   }

   // Convert UTC-like string "YYYY-MM-DD HH:mm:ss" to local Date (assumes server sent UTC)
   private convertToLocalTime(apiDateStr: string): Date {
      const isoDateStr = apiDateStr.replace(' ', 'T') + 'Z';
      return new Date(isoDateStr);
   }

   private consumeCrowdfundingProgress(res: any): void {
      // Map progress and investor counts
      this.progressPercent =
         Number(res?.ramadan_investor_progressbar_percent) || this.progressPercent;
      this.totalInvestorsTarget =
         Number(res?.ramadan_investor_total) || this.totalInvestorsTarget;
      this.remainingInvestors =
         Number(res?.ramadan_investor_remaining) || this.remainingInvestors;

      // Use investment_end_date to drive the countdown
      const endDateStr: string | undefined =
         res?.investment_end_date || res?.investment_countdown;
      if (endDateStr) {
         const deadline = this.convertToLocalTime(endDateStr);
         const now = new Date();
         if (now.getTime() > deadline.getTime()) {
            this.setCountdownToZero();
            this.countdownLoading = false;
         } else {
            // Start/Restart interval using API-driven deadline
            this.clearCountdown();
            this.updateCountdown(deadline);
            this.countdownInterval = setInterval(() => {
               this.updateCountdown(deadline);
            }, 1000);
         }
      }
   }
}
